export default "__VITE_ASSET__cgfw7Fi4__"